export enum ListSortType {
  Activity = 'LATEST_ACTIVITY',
  Alphabet = 'TITLE',
  Creation = 'CREATED_DATE',
  StartDateTime = 'START_DATE_TIME',
}
